/** Shared layout + type styles (matches Home / Discussions chrome). */

export const forumCard = 'overflow-hidden rounded-2xl border border-zinc-200 bg-white shadow-sm shadow-zinc-950/5'

export const forumCardHeader =
  'border-b border-zinc-100 bg-gradient-to-br from-zinc-50 to-white px-5 py-5 md:px-6 md:py-6'

export const forumSectionBar =
  'flex flex-wrap items-center justify-between gap-3 border-b border-zinc-100 bg-zinc-50/90 px-4 py-3 md:px-5'

export const forumKicker = 'text-xs font-semibold uppercase tracking-[0.18em] text-zinc-500'

export const forumTitleLg =
  'mt-2 text-[1.75rem] font-semibold tracking-tight text-zinc-950 md:text-[2rem]'

export const forumTitleMd =
  'mt-1 text-xl font-semibold tracking-tight text-zinc-950 md:text-2xl'

export const forumMuted = 'mt-2 max-w-[72ch] text-[15px] leading-relaxed text-zinc-600'

export const forumMutedSm = 'text-[14px] leading-relaxed text-zinc-600'

export const forumField =
  'h-10 w-full rounded-md border border-zinc-200 bg-white px-3 text-[15px] text-zinc-900 placeholder:text-zinc-400 focus:border-sky-500 focus:outline-none focus:ring-2 focus:ring-sky-500/30'

export const forumTextarea =
  'min-h-[120px] w-full rounded-md border border-zinc-200 bg-white px-3 py-2.5 text-[15px] text-zinc-900 focus:border-sky-500 focus:outline-none focus:ring-2 focus:ring-sky-500/30'

export const forumAlertError =
  'rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-[14px] font-medium text-red-900'

export const forumAlertWarn =
  'rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-[14px] font-medium text-amber-950'

export const forumAlertOk =
  'rounded-lg border border-emerald-200 bg-emerald-50 px-4 py-3 text-[14px] font-medium text-emerald-950'

export const forumLink = 'font-semibold text-sky-700 underline-offset-2 hover:text-zinc-950'

export const forumBtnPrimary = 'rounded-lg bg-sky-600 font-semibold text-white hover:bg-sky-500'

export const forumBtnOutline = 'rounded-lg border-zinc-200 font-semibold'

export const forumStatGrid =
  'mt-3 flex list-none flex-wrap gap-px rounded-xl border border-zinc-200 bg-zinc-100 p-0 text-[13px]'

export const forumStatCell =
  'min-w-[calc(50%-1px)] flex-1 border border-zinc-200 bg-white px-3 py-2 md:min-w-0'

export const forumLoaderRow =
  'flex items-center gap-2 rounded-xl border border-zinc-200 bg-white px-4 py-4 text-[14px] font-medium text-zinc-600 shadow-sm shadow-zinc-950/5'

export const forumEmptyBox =
  'rounded-2xl border border-dashed border-zinc-300 bg-zinc-50/80 px-5 py-10 text-[15px] text-zinc-700'
